<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.clients.loadingClients">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <!-- <v-card-title>
                    <v-list two-line color="grey" style="width:100%">
                        <transition-group name="data-list">
                            <data-list-tile v-for="(client) in filteredClients" :key="client.id" :client="client" class="data-list-item">
                                <v-btn icon flat color="grey" slot="action" @click="deleteClient(i, client)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </data-list-tile>
                        </transition-group>
                    </v-list>
        </v-card-title>-->
        <v-data-table
          :items="filteredClients"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Client" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(client,i) in filteredClients"
        :key="client.id"
        class="data-list-item"
      >
        <client-card :client="client" :index="i"></client-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientService from "@/services/requests/clientService";
import ClientCard from "@/components/clients/clientCard";
import ClientRow from "@/components/clients/clientRow";
import TableRow from "@/components/ui/masterFileTableRow";
export default {
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Contact Email",
          align: "left",
          value: "contactEmail"
        },
        {
          text: "ContactPhone",
          align: "right",
          value: "contactPhone"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  methods: {
    getObjectPath(path, object) {
      var props = path.split(".");

      while (props.length > 1) {
        object = object[props.shift()];
      }
      object = object[props.shift()];
      return object;
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "clients", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "clients", prop: "filterBy" }),
    clients: Store.getSet({ store: "clients", prop: "clients" }),
    listView: Store.getSet({ store: "clients", prop: "listView" }),
    sortedClients() {
      if (this.sortBy) {
        var path = this.sortBy;
        return this.clients.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == "updatedAt") {
              return 1;
            }
            return -1;
          } else {
            if (path == "updatedAt") {
              return -1;
            }
            return 1;
          }
        });
      } else {
        return this.clients;
      }
    },
    filteredClients() {
      return this.sortedClients.filter(client => {
        return (
          client.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        );
      });
      //return this.sortedClients;
    }
  },
  components: {
    ClientCard,
    TableRow
  }
};
</script>

<style scoped>
</style>
